import React, { useState } from 'react'
import './createdoc.css'
import Sidebar from '../../../components/Sidebar/Sidebar'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faSquareCheck, faUser } from '@fortawesome/free-solid-svg-icons'
import TopBar from '../../../components/topbar'

function CreateDoc() {

    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [dialog, setDialog] = useState('paragraph')

  return (
    <div className='create-doc'>
        <Sidebar />
        <div className="body">
           <TopBar/>
            <div className="back" onClick={() => window.history.back()}>
                <Link><FontAwesomeIcon icon={faAngleLeft} /> Back</Link>
            </div>
            <div className="create-body">
                <div className="form-wrap">
                    <div className="form-head">
                        <h2>Create Affidavit</h2>
                        <p>Fill the input fields to create affidavit</p>
                    </div>
                    <div className="form-rest">
                        <div className="form-inp">
                            <label htmlFor="doc-title">Affidavit Title</label>
                            <input type="text" placeholder='Enter Title e.g AFFIDAVIT OF CONSENT' id='doc-title'/>
                        </div>
                        <div className="form-inp">
                            <label htmlFor="paragraph">PARAGRAPH</label>
                            <textarea placeholder='Enter one paragraph statement at a time and click ADD without paragraph numbering or bullets, auto-numbering will take care of numbers' id='paragraph'></textarea>
                            <button onClick={() => setIsDialogOpen(true)}>Add</button>
                        </div>
                        <div className="form-inp">
                            <label htmlFor="doc-gender">Enter Gender</label>
                            <input type="text" placeholder='e.g MALE' id='doc-gender'/>
                        </div>
                        <div className="form-inp">
                            <label htmlFor="doc-occupation">Enter Occupation</label>
                            <input type="text" placeholder='e.g Lawyer' id='doc-occupation'/>
                        </div>
                        <div className="form-inp">
                            <label htmlFor="doc-dep">Enter Deponent Full Name</label>
                            <input type="text" placeholder='e.g Jessica Jones' id='doc-dep'/>
                        </div>
                        <div className="form-inp">
                            <label htmlFor="doc-religion">Enter Religion</label>
                            <input type="text" placeholder='e.g Traditional' id='doc-religion'/>
                        </div>
                        <div className="form-inp">
                            <label htmlFor="doc-title">Enter Address</label>
                            <input type="text" placeholder='711 D Close House 2, Festac Town Lagos' id='doc-title'/>
                        </div>
                        <div className="select-item">
                            <FontAwesomeIcon icon={faUser} />
                            <p>Click to select passport</p>
                        </div>
                        <Link to='/edm/create-temp/view-temp'><button className="red">Preview Document</button></Link>
                    </div>
                </div>
            </div>
            <div className="footer-tech">
                <p>Powered By First Hightower InfoTech</p>
                <p>© 2024</p>
            </div>
            <div className={ isDialogOpen ? "add-para open" : "add-para"}>
                {
                    dialog === 'paragraph' && <div className="add-para-box">
                        <FontAwesomeIcon icon={faSquareCheck} />
                        <h3>Would you like to add sub paragraphs to this paragraph?</h3>
                        <div className="add-btns">
                            <button className="red" onClick={() => setDialog('sub-paragraph')}>Yes</button>
                            <button className='black' onClick={() => setIsDialogOpen(false)}>No</button>
                        </div>
                    </div>
                }
                {
                    dialog === 'sub-paragraph' && <div className="add-para-box">
                        <div className="form-inp">
                            <input placeholder='Enter Subparagraph' id='paragraph' />
                            <button>Add</button>
                        </div>
                        <div className="add-btns">
                            <button className="red" onClick={() => setDialog('paragraph')}>Cancel</button>
                            <button className='black' onClick={() => setIsDialogOpen(false)}>Proceed</button>
                        </div>
                    </div>
                }
                
            </div>
        </div>
    </div>
  )
}

export default CreateDoc